import { createContext, useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { UI } from './ui';
import { toEnPath, toItPath } from './slugs';

const LangContext = createContext({ lang: 'it', lp: (p) => p, t: (k) => k });

export const LangProvider = ({ children }) => {
  const { pathname } = useLocation();
  const lang = pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'it';

  const lp = (path) => {
    if (lang !== 'en') return path;
    const enPath = toEnPath(path);
    if (enPath === '/') return '/en';
    return '/en' + enPath;
  };

  const t = (key) => UI[lang][key] ?? UI.it[key] ?? key;

  const switchPath = (target) => {
    if (target === 'en') {
      if (lang === 'en') return pathname;
      const enPath = toEnPath(pathname);
      return enPath === '/' ? '/en' : '/en' + enPath;
    }
    if (lang !== 'en') return pathname;
    const noPrefix = pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    return toItPath(noPrefix);
  };

  return <LangContext.Provider value={{ lang, lp, t, switchPath }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const LangLink = ({ to, children, ...props }) => {
  const { lp } = useLang();
  return <Link to={lp(to)} {...props}>{children}</Link>;
};
